import React, { useState } from 'react';
import { Button, Alert } from 'ui';
import { useCurrentUser } from '../../hooks/users/queries';
import UpdateEmailModal from './UpdateEmailModal';
import API from 'apis/API';

const LEFT_MARGIN = "30px";
const divStyle = { margin: LEFT_MARGIN };

const ProfileComponent = ({ changePassword }) => {
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [resendStatus, setResendStatus] = useState(null); // null | 'sent' | 'error'
  const { data: currentUser } = useCurrentUser();

  const handleResendConfirmation = async () => {
    try {
      await API.post('/api/auth/confirmation', { email: currentUser.email });
      setResendStatus('sent');
    } catch (err) {
      setResendStatus('error');
    }
  };

  return (
    <div>
      <div style={{ margin: `10px ${LEFT_MARGIN}` }}>
        <h4>Profile</h4>
        <div><strong>Name</strong></div>
        <div>{currentUser ? currentUser.name : ""}</div>
      </div>
      <div style={divStyle}>
        <div><strong>Email</strong></div>
        <div>{currentUser ? currentUser.email : ""}</div>

        {currentUser?.unconfirmed_email && (
          <Alert variant="warning" style={{ display: 'inline-block', marginTop: '8px', marginBottom: '0', padding: '8px 12px', fontSize: '13px' }}>
            Pending email change to <strong>{currentUser.unconfirmed_email}</strong>. Check your inbox to confirm.
          </Alert>
        )}

        {currentUser && !currentUser.confirmed_at && !currentUser.unconfirmed_email && (
          <Alert variant="warning" style={{ display: 'inline-block', marginTop: '8px', marginBottom: '0', padding: '8px 12px', fontSize: '13px' }}>
            Email not confirmed.{' '}
            {resendStatus === 'sent' ? (
              <span>Confirmation sent.</span>
            ) : (
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); handleResendConfirmation(); }}
                style={{ color: 'inherit', textDecoration: 'underline' }}
              >
                Resend confirmation
              </a>
            )}
          </Alert>
        )}
      </div>

      <div style={divStyle}>
        <Button variant='blue' onClick={changePassword}>Change Password</Button>
        {' '}
        <Button variant='blue' onClick={() => setShowEmailModal(true)}>Change Email</Button>
      </div>

      <UpdateEmailModal
        show={showEmailModal}
        onHide={() => setShowEmailModal(false)}
      />
    </div>
  );
};

export default ProfileComponent;
